import React, { useEffect, useRef, useState } from 'react';
import ChatbotInitializer from './ChatbotInitializer';
import ChatbotSupportButton from './ChatbotSupportButton';
import { getChatbotConfig, getGrowthbookConfig } from '../../config/config';
import { resolveShowChatbot } from '../../lib/resolveShowChatbot';

const WrapperChatbot = ({ hasError, errorCode }) => {
  const chatbotContainerRef = useRef(null);
  const chatbot = getChatbotConfig();
  const {
    apiHost,
    clientKey,
    featureKey,
    fallback,
    gaClientIdTimeoutMs,
  } = getGrowthbookConfig();
  const [showChatbot, setShowChatbot] = useState(fallback);

  useEffect(() => {
    if (!chatbot.enabled) {
      return undefined;
    }

    let cancelled = false;

    resolveShowChatbot({
      apiHost,
      clientKey,
      featureKey,
      fallback,
      gaClientIdTimeoutMs,
    }).then((show) => {
      if (!cancelled) {
        setShowChatbot(show);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [chatbot.enabled, apiHost, clientKey, featureKey, fallback, gaClientIdTimeoutMs]);

  if (!chatbot.enabled || showChatbot !== true) {
    return null;
  }

  return (
    <>
      <div ref={chatbotContainerRef} />
      <ChatbotInitializer
        chatbotContainerRef={chatbotContainerRef}
        hasError={hasError}
        errorCode={errorCode}
      />
      <ChatbotSupportButton />
    </>
  );
};

export default WrapperChatbot;
